<template>
	<v-menu
		v-model="showTasksMenu"
		:close-on-content-click="false"
		left
		:nudge-left="0"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-icon color="blue darken-2" v-bind="attrs" v-on="on"
					size="28" class="mr-3"
				>fa-fw far fa-list</v-icon
			>
		</template>
		<v-card width="300">
			<v-card-text
				style="max-width: 400px; max-height: 80vh; overflow-y: auto;"
			>
				<v-skeleton-loader
					v-if="loadingBookings"
					type="list-item, list-item, list-item"
				></v-skeleton-loader>
				<div
					v-if="!loadingBookings && bookings.length === 0"
					class="text-center pa-2 grey lighten-2 rounded my-2 poppins-regular"
				>
					Non ci sono prenotazioni per questo paziente.
				</div>
				<div v-if="!loadingBookings  && bookings.length > 0">
					<h3 class="poppins-semibold mb-2">Appuntamenti del paziente</h3>
					<div
						v-for="booking in bookings"
						:key="booking.BookingId"
						class="pa-2 grey lighten-3 rounded poppins-regular mb-2"

					>
						<div class="poppins-medium mb-1">
							{{
								moment(booking.BookingTime).format("DD/MM/YYYY HH:mm")
							}}
						</div>
						<div class="d-flex ">
							<nutriYouBookingTypeChip
								class="mr-1"
								:StatusId="booking.BookingTypeId"
								small
								label
							></nutriYouBookingTypeChip>
							<v-spacer></v-spacer>
							<nutriYouOrderStatusChip
								class="ml-1"
								:StatusId="booking.BookingStatusId"
							></nutriYouOrderStatusChip>
						</div>
						<NutritionistBookingListActions :booking="booking" @bookingModified="LoadBookings"></NutritionistBookingListActions>

					</div>
				</div>
			</v-card-text>
		</v-card>
	</v-menu>
</template>
<script>
import moment from "moment/moment";
import CrudClient from "@/services/CrudClient";
import { mapActions } from "vuex";
import nutriYouOrderStatusChip from "@/components/NutriYou/nutriYouOrderStatusChip.vue";
import nutriYouBookingTypeChip from "@/components/NutriYou/nutriYouBookingTypeChip.vue";
import NutritionistBookingListActions from "@/components/Chat/Message/NutritionistBookingListActions.vue";

export default {
	name: "NutritionistBookingsList.vue",
	components: { NutritionistBookingListActions, nutriYouBookingTypeChip, nutriYouOrderStatusChip },
	data() {
		return {
			showTasksMenu: false,
			loadingBookings: false,
			bookings: []
		};
	},
	props: {
		Conversation: {
			type: Object,
			required: true
		}
	},
	watch: {
		showTasksMenu: async function(val) {
			this.$log.debug(val);
			if (val) {
				await this.LoadBookings();
			}
		}
	},
	created() {
		this.moment = moment;
		this.BookingsService = new CrudClient("CurrentNutritionist/Bookings");
	},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),

		async LoadBookings() {
			try {
				this.loadingBookings = true;
				const res = await this.BookingsService.GetPaged({
					limit: 10,
					skip: 0,
					fields:
						"BookingId, BookingTime, BookingStatusId, BookingTypeId",
					filter:
						"PatientUserId:" +
						this.Conversation.UserId +
						";BookingStatusId:noteq:3",
					orderBy: "BookingTime:desc"
				});

				this.bookings = res.Data;
			} catch (error) {
				this.$captureError(error);
				this.snackError({
					Text: this.$t("common.error.cannotLoadData")
				});
			} finally {
				this.loadingBookings = false;
			}
		}
	}
};
</script>
<style scoped lang="scss"></style>
